import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { useLocationList } from '@/features/configuration-management/location/hooks/useLocationList';
import { LocationsTable } from '@/features/configuration-management/location/table';

import { Translation } from '@/hoslog-intl';
import { Location as LocationIcon } from '@/icons';

const sortItemSchema = z.object({
  id: z.enum(['locationTitle', 'locationSubtitle', 'totalClubs', 'status']),
  desc: z.boolean(),
});

const locationsSearchSchema = z
  .object({
    sort: z
      .preprocess((val) => {
        if (typeof val === 'string') {
          try {
            return JSON.parse(val);
          } catch {
            return undefined;
          }
        }
        return val;
      }, z.array(sortItemSchema))
      .optional(),

    createdDate: z.string().optional(),

    q: z
      .any()
      .transform((val) => (val == null ? undefined : String(val)))
      .optional(),

    status: z
      .string()
      .transform((val) => val.split(','))
      .pipe(z.array(z.enum(['ACTIVE', 'BLOCKED'])))
      .optional(),

    page: z.coerce.number().positive().catch(0),
    fetch: z.coerce.number().positive().max(100).catch(5),
  })
  .passthrough();

export const Route = createFileRoute('/(app)/configuration-management/location/')({
  loader: () => {
    return {
      crumb: <CrumbTitle id="configurationManagement.location.crumb.locationManagement" icon={LocationIcon} />,
      title: <Translation id="configurationManagement.location.crumb.locationManagement" />,
    };
  },
  errorComponent: ({ error }) => {
    return <div>{error.message}</div>;
  },
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => locationsSearchSchema.parse(search),
});

function RouteComponent() {
  const { locations, pagination, loading } = useLocationList();
  return <LocationsTable data={locations} pagination={pagination} loading={loading} />;
}
